<template>
    <div>
        <div class="ml-auto mb-3 text-right">
            <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                :data="exportData"
                :fields="exportFields"
                :header="exportHeaders"
                type="csv"
                :escapeCsv="false"
                :name="exportFileName">
                <span>CSV</span>
            </exportCSV>
            <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                <span class="mr-3">PDF</span>
                <i class="arrow-down fas fa-angle-down"></i> 
            </button> -->
        </div>
        <div class="row">
            <div class="col-sm-12 col-md-4 mb-2">
                <div class="dataTables_filter">
                    <label class="d-flex mb-0">
                        <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="search" @keypress.enter="filterSearch">
                        <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0 search" @click="filterSearch">
                            <i class="fas fa-search"></i>
                        </button>
                    </label>
                </div>
            </div>
            <div class="col-sm-12 col-md-4 mb-2">
                <date-range-picker class="w-100"
                    :minDate="minDate"
                    ref="picker"
                    v-model="dateRange"
                    :opens="'right'"
                    :autoApply="true"
                    :showDropdowns="true" 
                    :always-show-calendars="false"
                    :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}"
                    @showCustomRange="showCustomRangeCalendars=true"
                    @update="filterByDate">
                </date-range-picker>
            </div>
            <div class="col-sm-12 col-md-4 mb-2 mb-2">
                <div class="form-group">
                    <div class="input-group">
                        <div class="input-group-prepend w-100">
                            <label class="input-group-text border-right-0" for="serviceCategory">
                                <i class="fas fa-store"></i>
                            </label>
                            <multiselect 
                                :value="selectedOutlet"
                                label="text"
                                track-by="id"
                                :options="outlet"
                                :searchable="false"
                                :show-labels="false"
                                openDirection="below"
                                @select="outlerFilterSelect"
                                @remove="outlerFilterRemove"
                                :limit="1"
                                :multiple="true"
                                :close-on-select="false"
                                :clear-on-select="false"
                                group-values="outlets"
                                group-label="group"
                                :group-select="true"
                                >
                                <template slot="option" slot-scope="props">
                                    <div>
                                        <span>{{ props.option.text || props.option['$groupLabel'] }}</span>
                                        <span v-if="!props.option.id"></span>
                                        <i style="float:right" class="fas fa-circle color-primary-500" v-else-if="selectedOutlet.some(k => k['id'] === props.option['id'])"></i>
                                        <i style="float:right" class="far fa-circle color-primary-500" v-else></i>
                                    </div>
                                </template>
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="tab == 'date'">
            <b-form-group :label="$t('label.payment_type')" v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                    id="radPaymentType"
                    v-model="selectedPaymentType"
                    :options="radPaymentType"
                    :aria-describedby="ariaDescribedby"
                    name="radPaymentType"
                    @change="filterByPaymentType"
                ></b-form-radio-group>
            </b-form-group>
            <div v-show="selectedPaymentType == 'customize'" class="border-top pt-3">
                <label class="form-label mb-2">{{$t('label.select', {'item': $t('table.header.payment_method')})}}</label>
                <div class="row">
                    <div class="col-sm-12 col-md-4">
                        <div v-for="pt in paymentType.slice(0, 7)" :key="pt.paymentTypeID" class="custom-control custom-checkbox mb-3">
                            <input type="checkbox" class="custom-control-input" :id="'cbx_paymentType_'+ pt.paymentTypeID" v-model="hasPaymentType[pt.paymentTypeID]">
                            <label class="custom-control-label text-capitalize" :for="'cbx_paymentType_'+ pt.paymentTypeID">{{pt.title}}</label>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-4">
                        <div v-for="pt in paymentType.slice(7, 13)" :key="pt.paymentTypeID" class="custom-control custom-checkbox mb-3">
                            <input type="checkbox" class="custom-control-input" :id="'cbx_paymentType_'+ pt.paymentTypeID" v-model="hasPaymentType[pt.paymentTypeID]">
                            <label class="custom-control-label text-capitalize" :for="'cbx_paymentType_'+ pt.paymentTypeID">{{pt.title}}</label>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-4">
                        <div v-for="pt in paymentType.slice(13, 19)" :key="pt.paymentTypeID" class="custom-control custom-checkbox mb-3">
                            <input type="checkbox" class="custom-control-input" :id="'cbx_paymentType_'+ pt.paymentTypeID" v-model="hasPaymentType[pt.paymentTypeID]">
                            <label class="custom-control-label text-capitalize" :for="'cbx_paymentType_'+ pt.paymentTypeID">{{pt.title}}</label>
                        </div>
                    </div>
                </div>
                <div class="text-right pb-4">
                    <button type="button" class="btn btn-primary waves-effect waves-themed" @click="filterCustomize">{{$t('button_link.apply')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import {getPaymentTypeTitle} from './../../../../assets/js/dashboard/salonReport/salonReport'
import {handleSessionExpired, getOutletName, getOutletList} from '@/assets/js/dashboard/dashboard.js'
import {getMinDate} from '@/assets/js/dashboard/utilities.js'

export default {
    name: 'paymentFilter',
    components:{
        DateRangePicker
    },
    props:{
        paymentType: {type: Array}
    },
    data(){
        let startDate = moment().startOf('month').toDate();
        let endDate = moment().endOf('month').toDate()
        return{
            minDate: getMinDate(),//moment().startOf('year').format('YYYY-MM-DD'),
            
            tab: 'date',
            search: "",
            dateRange: { startDate, endDate },
            selectedPaymentType: "current",
            outlet: [{id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})}],
            selectedOutlet: [],
            exportHeaders: [], exportFields: {}, exportData: [], exportFileName: "",
        }
    },
    computed:{
        hasPaymentType(){
            var ret = {};
            for(var i=0; i<this.paymentType.length; i++){
                ret[this.paymentType[i].paymentTypeID] = false;
            }
            return ret
        },
        radPaymentType(){
            return[
                { text: this.$i18n.t('label.current'), value: 'current' },
                { text: this.$i18n.t('label.all', {'item': ''}), value: 'all' },
                { text: this.$i18n.t('label.customize'), value: 'customize' },
            ]
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.setOutletFilter()
        }
    },
    methods:{
        setExportData(item){
            this.exportData = item.exportData
            this.exportFields = item.exportFields
            this.exportFileName = item.exportFileName
            this.exportHeaders = item.exportHeaders
        },
        filterSearch(){
            this.setFilter()
        },
        outlerFilterSelect(item){
            if(Array.isArray(item)) {
                this.selectedOutlet = this.selectedOutlet.concat(item)
            } else {
                this.selectedOutlet.push(item)
            }
            this.setFilter()
        },
        outlerFilterRemove(item){
            this.selectedOutlet = this.selectedOutlet.filter(k => k.id !== item.id)
            this.setFilter()
        },
        filterByPaymentType(e){
            this.selectedPaymentType = e
            if(e != 'customize'){
                this.setFilter()
            }
        },
        filterCustomize(){
            this.setFilter()
        },
        filterByDate(date){
            this.dateRange = date
            this.setFilter()
        },
        setFilter(){
            var paymentMethod = []
            if(this.selectedPaymentType == 'customize'){
                for(var k in this.hasPaymentType){
                    if(this.hasPaymentType[k]){
                        paymentMethod.push({
                            paymentTypeID: parseInt(k),
                            title: getPaymentTypeTitle(k, this.paymentType)
                        })
                    }
                }
            }else if(this.selectedPaymentType == 'all'){
                paymentMethod = this.paymentType
            }
            
            var data = {
                date: this.dateRange,
                paymentType: this.selectedPaymentType,
                paymentMethod: paymentMethod,
                search: this.search,
                outlet: this.selectedOutlet
            }
            this.$emit('filterPayment', data)
        },
        setOutletFilter() {
            this.outlet = [{ group: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')}), outlets: [] }]
            this.outlet[0]['outlets'] = JSON.parse(this.$store.state.outlets)
        }
    },
    async mounted(){
        let $vm = this
        await getOutletList($vm)
        $vm.setOutletFilter()
        this.selectedOutlet = this.outlet[0]['outlets']
        $vm.setFilter()
    }
}
</script>